import React, { useId, useState } from 'react';

import { IconArrowDown, IconArrowUp } from '$partials/icon/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/ui.d.ts').Disclosure}
 */
const Disclosure = ({
    children,
    heading,
    isOpenByDefault = false
}) => {
    const id = useId();

    const [isOpen, setIsOpen] = useState(isOpenByDefault);

    return (
        <div className='border-t border-neutral-400 first:border-t-0'>
            <h2>
                <button
                    aria-controls={id}
                    aria-expanded={isOpen}
                    className='w-full flex items-start justify-between gap-x-8 py-10 sm:py-16 text-left cursor-pointer type-style-body-bold'
                    onClick={() => setIsOpen(!isOpen)}
                    type='button'>
                    {heading}

                    <span className='shrink-0'>
                        <IconArrowDown
                            className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                            height={20}
                            width={20} />
                    </span>
                </button>
            </h2>

            <div
                hidden={!isOpen}
                id={id}>
                {children}
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default Disclosure;
